module.exports = __webpack_public_path__ + "img/br31.0fa7b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br31.jpg
// module id = x632
// module chunks = 0